var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345:102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5416 15.9515H14.8931C14.5695 15.9515 14.3071 16.2139 14.3071 16.5375C14.3071 16.8611 14.5695 17.1234 14.8931 17.1234H14.9304C13.4606 18.1437 11.7116 18.6829 9.8907 18.6591C7.62004 18.6299 5.485 17.7292 3.87895 16.1231C3.38543 15.6296 2.95633 15.0839 2.59793 14.4947H4.98852C5.31211 14.4947 5.57445 14.2323 5.57445 13.9087V6.15491C5.57445 5.83131 5.31211 5.56897 4.98852 5.56897H0.585938C0.262344 5.56897 0 5.83131 0 6.15491V13.9087C0 14.2323 0.262344 14.4947 0.585938 14.4947H1.25602C1.72121 15.3994 2.3243 16.2258 3.05031 16.9518C4.87371 18.7752 7.29762 19.7977 9.87562 19.8309C9.91895 19.8315 9.96203 19.8317 10.0053 19.8317C12.1766 19.8317 14.2506 19.1273 15.9557 17.826V18.186C15.9557 18.5096 16.218 18.7719 16.5416 18.7719C16.8652 18.7719 17.1276 18.5096 17.1276 18.186V16.5374C17.1275 16.2139 16.8652 15.9515 16.5416 15.9515V15.9515ZM1.17188 6.74084H4.40258V13.3228H1.17188V6.74084Z",
    fill: "#67665E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4142 5.89637H18.9329C18.447 4.83786 17.7803 3.88032 16.9487 3.04864C15.1376 1.23754 12.7303 0.215277 10.1701 0.170199C7.9379 0.131683 5.79548 0.837113 4.04333 2.17368V1.81438C4.04333 1.49078 3.78099 1.22844 3.4574 1.22844C3.1338 1.22844 2.87146 1.49078 2.87146 1.81438V3.46289C2.87146 3.78649 3.1338 4.04883 3.4574 4.04883H5.10591C5.42951 4.04883 5.69185 3.78649 5.69185 3.46289C5.69185 3.1393 5.42951 2.87696 5.10591 2.87696H5.06833C6.5499 1.84871 8.31525 1.30973 10.1495 1.34184C12.4044 1.38161 14.5248 2.28196 16.1201 3.87719C16.7225 4.47965 17.2264 5.15688 17.6244 5.89629H15.0116C14.688 5.89629 14.4256 6.15864 14.4256 6.48223V13.8454C14.4256 14.169 14.688 14.4314 15.0116 14.4314H19.4142C19.7377 14.4314 20.0001 14.169 20.0001 13.8454V6.48231C20.0001 6.15868 19.7377 5.89637 19.4142 5.89637V5.89637ZM18.8282 13.2596H15.5975V7.06825H18.8282V13.2596Z",
    fill: "#67665E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.599976,
    y: 6.5,
    width: 4.5,
    height: 7,
    fill: "#67665E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.9,
    y: 6.5,
    width: 4.5,
    height: 7,
    fill: "#67665E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345:102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.22ed78ec8f85da3c4bc3a402403aa62c.svg";
export { ForwardRef as ReactComponent };